import React from 'react';
import apiService from '../../../services/api';
import { DashboardContainer } from './DashboardES.styles';
import Navbar from '../../../components/layout/Navbar/Navbar';
import Sidebar from '../../../components/layout/Sidebar/Sidebar';
import BemVindoComponent from '../../../components/Dashboard-ES/BemVindoComponent';
import DashboardContent from '../../../components/Dashboard-ES/DashBoardContent';
import { ESTABELECIMENTO_SAUDE_SIDEBAR } from '../../../constants/sidebarConfig';

const DashboardES = () => {
  return (
    <DashboardContainer>
      <Navbar 
        onLogout={apiService.logout}
        showHome={true}
        showNotifications={true}
        showProfile={true}
        showLogout={true}
      />
      <Sidebar items={ESTABELECIMENTO_SAUDE_SIDEBAR} />
      <main className="main-content">
        <BemVindoComponent />
        <DashboardContent />
      </main>
    </DashboardContainer>
  );
};

export default DashboardES;